/*LIBRARY*/
import React, { useState } from "react";
import { connect } from "react-redux";

/*COMPONENT*/

/*REDUX*/
import { requestFreeImport } from "../../App/actions/blogAction";

/*PICTURE*/

/*FUNCTION*/

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/

const RequestFree = ({ auth, blog, requestFreeImport }) => {
  const [state, setState] = useState({
    free_message: "",
  });

  const handleChange = (e) => {
    e.preventDefault();
    const target = e.target;
    const value = target.value;
    const name = target.name;
    setState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { free_message } = state;
    const { user } = auth;
    const { blog: blog_data } = blog;
    const body = {
      blog_id: blog_data._id,
      user_id: user._id, //Dari server ga butuh user_id, tapi di FE butuh
      free_message,
    };
    requestFreeImport(body);
  };

  //local storage
  const language = localStorage?.language || auth.language;

  //local state
  const { free_message } = state;

  //global props
  const { loadingProcess, itemLoading } = blog;

  //content
  let buttonContent;
  if (loadingProcess && itemLoading === "request_free_import") {
    buttonContent = (
      <button className="button_big background_grey">
        {dict["Sending"][language]}...
      </button>
    );
  } else {
    buttonContent = (
      <button type="submit" className="button_big background_black">
        {dict["Send request"][language]}
      </button>
    );
  }

  return (
    <main>
      <h1>{dict["Your message request"][language]}</h1>
      <form onSubmit={handleSubmit}>
        <textarea
          rows="7"
          type="text"
          name="free_message"
          id="free_message"
          value={free_message}
          onChange={handleChange}
        />
        {buttonContent}
      </form>
    </main>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  blog: state.blog,
});

export default connect(mapStateToProps, { requestFreeImport })(RequestFree);
